import { render, staticRenderFns } from "./MaterialStatsOutlineCard.vue?vue&type=template&id=59e0f066&scoped=true&"
import script from "./MaterialStatsOutlineCard.vue?vue&type=script&lang=js&"
export * from "./MaterialStatsOutlineCard.vue?vue&type=script&lang=js&"
import style0 from "./MaterialStatsOutlineCard.vue?vue&type=style&index=0&id=59e0f066&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59e0f066",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VContainer,VIcon})
